import { render } from "./WpeCode.vue?vue&type=template&id=b5af1b60"
import script from "./WpeCode.vue?vue&type=script&lang=js"
export * from "./WpeCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeCode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b5af1b60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b5af1b60', __exports__)) {
    api.reload('b5af1b60', __exports__)
  }
  
  module.hot.accept("./WpeCode.vue?vue&type=template&id=b5af1b60", () => {
    api.rerender('b5af1b60', render)
  })

}


export default __exports__